import { Link } from "@inertiajs/react";
import Callout from "@/components/help/Callout";

export default function DonatingWithoutAnAccount() {
  return (
    <>
      <p>
        Donating doesn't create an account. You type your name, email, and card; we charge it; you get a receipt. Done. Coming back to donate to a different child later works the same way — no signup, no password, no profile.
      </p>

      <h2>Why no account?</h2>
      <p>
        Most people donate to a read-a-thon once or twice a year. Making you set up an account and remember a password just to do that would lose donations. So we don't.
      </p>

      <h2>What we keep</h2>
      <p>
        Your name and email (so we can send your receipt and help with refunds if needed), the donation amount, and the last four digits of your card. We never see your full card number, and we don't ask for your address or phone number — we don't need them.
      </p>

      <Callout variant="privacy" title="We don't build a donor profile">
        <p>
          If you donate to two different children at two different schools, we don't tie those together or learn anything about you. Each donation is its own record at its own school.
        </p>
      </Callout>

      <h2>Coming back later</h2>
      <p>
        Your receipt has a link you can bookmark to come back to any time. To donate again, just open the same link the family shared with you. We'll ask for your card again — same as the first time.
      </p>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/making-a-donation">How to make a donation</Link>.</li>
        <li><Link href="/help/articles/donor-receipts-and-refunds">Receipts and refunds</Link>.</li>
      </ul>
    </>
  );
}
